import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';

export const WaveRight = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1561"
    height="494"
    viewBox="0 0 1561 494.115"
    className={className}
    {...props}>
    <path
      d="M3835,336V819H2274c0-80.16,41.96-156,120-156,73.56,0,125,68,199,68,111.47,0,147.11-146.66,279-90,254.9,109.52,148.72-232.21,433-121,194.25,76,247.13-42.13,330-125C3743.06,286.925,3835,336,3835,336Z"
      transform="translate(-2274 -324.881)"
      fill="#fff"
      className="l-homepage-hero-lab__wave-right-path"
    />
  </svg>
);

WaveRight.propTypes = {
  className: PropTypes.string,
};

WaveRight.defaultProps = {
  className: '',
};
